import { track } from "@amplitude/analytics-react-native";
import { useEffect, useState } from "react";
import { View } from "react-native";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { amp } from "src/api/amplitude";
import { FILTER_SORT_MENU } from "src/api/featureFlags";
import Loading from "src/components/Loading";
import { BasicModularNavBarTemplate } from "src/components/ModularNavBar";
import Touchable from "src/components/Touchable";
import { useGatheringStore } from "src/contexts/GatheringContext";
import parseHitSlop from "src/helpers/parseHitSlop";
import useDevice from "src/hooks/useDevice";
import useKeyboardListener from "src/hooks/useKeyboardListener";
import useRouter from "src/hooks/useRouter";
import IconLeft from "src/icons/IconLeft";
import DynamicSelectButton from "./DynamicSelectButton";
import FilterButton from "./FilterButton";
import FilterDisplay from "./FilterDisplay";
import GatheringHomeAudioPlayerDisplay from "./GatheringHomeAudioPlayerDisplay";

const Filter = FILTER_SORT_MENU ? FilterButton : FilterDisplay;

const LoadingIndicator = () => {
	const loading = useGatheringStore((state) => state.loadingForNavBar);
	const [shouldRender, setShouldRender] = useState(false);
	const opacitySV = useSharedValue(0);
	useEffect(() => {
		if (loading) {
			setShouldRender(true);
			opacitySV.value = withTiming(1, { duration: 200 });
			return;
		} else {
			// callback fn not working correctly here for some reason
			opacitySV.value = withTiming(0, { duration: 100 });
			const timeout = setTimeout(() => {
				if (opacitySV.value === 0) setShouldRender(false);
			}, 250);
			return () => clearTimeout(timeout);
		}
	}, [loading, opacitySV]);
	const animatedStyle = useAnimatedStyle(
		() => ({
			opacity: opacitySV.value,
		}),
		[opacitySV],
	);

	if (!shouldRender && !loading) return null;
	return (
		<Animated.View style={animatedStyle}>
			<Loading testID="QueryLoadingIndicator" />
		</Animated.View>
	);
};

const DefaultGatheringHomeNavBarContent = () => {
	const { native } = useDevice();
	const setSelectMode = useGatheringStore((state) => state.setSelectMode);

	const handleSelectEnabled = () => {
		track(amp.gathering.selectButtonPressed);
		setSelectMode("Select");
	};

	useKeyboardListener({
		Enter: handleSelectEnabled,
	});

	const router = useRouter();
	const { device } = useDevice();

	return (
		<BasicModularNavBarTemplate
			includeLogo={device === "desktop"}
			items={[
				native
					? () => (
							<Touchable onPress={router.back} hitSlop={parseHitSlop(20)}>
								<IconLeft size={20} />
							</Touchable>
						)
					: () => <View />,
				[LoadingIndicator, Filter, GatheringHomeAudioPlayerDisplay, DynamicSelectButton],
			]}
		/>
	);
};

export default DefaultGatheringHomeNavBarContent;
